import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button-white',
  templateUrl: './st-button-white.component.html',
  styleUrls: ['./st-button-white.component.scss'],
  standalone: false
})
export class StButtonWhiteComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  primary = false;

  @Input()
  label = 'Cancel';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000'

  @Output()
  onClick = new EventEmitter<Event>();
}
